import styled from '@emotion/styled'

export const Floater = styled.div`
  width: calc(100% - 32px);
  position: fixed;
  margin-bottom: 34px;
  padding: 0 16px;
  bottom: 0;
`
